import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import GenericFormDrawer from '../../components/GenericFormDrawer';
import GenericSelect from '../../components/ui/GenericSelect';
import { getSurveyTemplates, createSurveyFromTemplate } from '../../services/surveyReportService';

// Hazır şablondan taslak anket (spec §10.4). Şablon boyutları, kodları, kırılım sorularını ve rapor ayarlarını
// sunucuda kurar; İK taslağı /surveys/{id}/edit akışında (soru düzenleyici, adım 1) gözden geçirir. Yalnız Anketler (SV)
// modülü gerekir; AI+ gerekmez (spec 2026-10-16 S6).

const Description = styled.div`
  margin-top: 12px;
  font-size: 13px;
  line-height: 1.5;
  color: ${({ theme }) => theme.colors.text.primary};
`;

const Hint = styled.div`
  margin-top: 12px;
  font-size: 12px;
  color: ${({ theme }) => theme.colors.text.muted};
`;

export default function TemplateStartDrawer({ open, onClose }) {
  const { t, i18n } = useTranslation();
  const history = useHistory();
  const [templates, setTemplates] = useState([]);
  const [templateId, setTemplateId] = useState(null);

  useEffect(() => {
    if (!open) return undefined;
    let alive = true;
    setTemplateId(null);
    getSurveyTemplates(i18n.language).then((res) => {
      if (!alive) return;
      const list = res?.data?.data;
      setTemplates(Array.isArray(list) ? list : []);
    });
    return () => { alive = false; };
  }, [open, i18n.language]);

  const selected = templates.find((x) => x.id === templateId);

  const handleSave = async () => {
    if (!templateId) return false;
    const res = await createSurveyFromTemplate({ templateId, language: i18n.language });
    const id = res?.data?.data?.id;
    if (!id) return false;
    history.push(`/surveys/${id}/edit`);
    return true;
  };

  return (
    <GenericFormDrawer
      open={open}
      onClose={onClose}
      title={t('survey.template.drawerTitle')}
      submitLabel={t('survey.template.create')}
      schema={[]}
      onSave={handleSave}
    >
      <GenericSelect
        label={t('survey.template.select')}
        options={templates}
        labelKey="title"
        value={templateId}
        onChange={setTemplateId}
        required
      />
      {selected?.description && <Description>{selected.description}</Description>}
      <Hint>{t('survey.template.hint')}</Hint>
    </GenericFormDrawer>
  );
}
